import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import { useState, useContext } from 'react';
import { TextField, Grid2 } from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { GlobalStyles } from '@mui/material';
import { userRegister } from "../../../Services/auth";
import './Login.css';
import { useTheme } from '@mui/material/styles';
import { ThemeContext } from '../../DarkMode/ThemeProvider';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ToastError, ToastSuccess } from "../../../CustomToaster/CustomToaster";
import { updateOtpTime } from '../../../Actions/AuthAction';
import { useSelector, useDispatch } from "react-redux";
import { InputError } from '../../Errors/ErrorText';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { parsePhoneNumber, getExampleNumber, parsePhoneNumberFromString } from 'libphonenumber-js';
import lightLogo from '../../../Images/fouchain-logo-light.svg';
import darkLogo from "../../../Images/fouchain-logo-dark.svg";


const Register = () => {
    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };


    const [showPassword1, setShowPassword1] = React.useState(false);

    const handleClickShowPassword1 = () => setShowPassword1((show) => !show);

    const handleMouseDownPassword1 = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword1 = (event) => {
        event.preventDefault();
    };
    const theme = useTheme();
    const { isLightMode, handleDarkmode } = useContext(ThemeContext);

    //custom code
    const navigate = useNavigate();

    const [allUsers, setAllUsers] = React.useState({
        email: "",
        phonenumber: "",
        registercheck: false,
        confirmPassword: "",
        password: "",
        country: "IN",
        referralCode: "",
        type: "register",
        firstName: "",
        lastName: "",
    });

    const [errors, setErrors] = React.useState({
        email: "",
        phonenumber: "",
        registercheck: false,
        password: "",
        confirmPassword: "",
        country: "",
        referralCode: "",
        firstName: "",
        lastName: "",
    });


    const [load, setLoad] = useState(false);
    const [check, setCheck] = useState(false);
    const { isAuthenticated } = useSelector((state) => state.auth);
    const [passwordLengthValid, setPasswordLengthValid] = useState(null);
    const [hasUpperLowerCase, setHasUpperLowerCase] = useState(null);
    const [hasNumber, setHasNumber] = useState(null);
    const [hasSpecialChar, setHasSpecialChar] = useState(null);

    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const refCode = queryParams.get("refCode");

    const handleChange = (e) => {
        const { name, value } = e.target;
        const fieldValue = value.trim();

        if (name === "password") {
            // Limit max length
            if (fieldValue.length > 30) {
                return;
            }

            let passwordError = "";

            if (!fieldValue) {
                passwordError = "Password is required";
            } else if (fieldValue.length < 8 || fieldValue.length > 30) {
                passwordError = "Password must be 8-30 characters long";
            } else if (!/[a-z]/.test(fieldValue)) {
                passwordError = "Password must include lowercase letters";
            } else if (!/[A-Z]/.test(fieldValue)) {
                passwordError = "Password must include uppercase letters";
            } else if (!/\d/.test(fieldValue)) {
                passwordError = "Password must include at least one number";
            } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(fieldValue)) {
                passwordError = "Password must include at least one special character";
            }

            setErrors((prev) => ({ ...prev, password: passwordError }));

            //  Re-validate confirmPassword when password changes
            if (allUsers.confirmPassword && allUsers.confirmPassword !== fieldValue) {
                setErrors((prev) => ({ ...prev, confirmPassword: "Passwords do not match" }));
            } else {
                setErrors((prev) => ({ ...prev, confirmPassword: "" }));
            }
        }

        if (name === "confirmPassword") {
            let confirmPasswordError = "";

            if (!fieldValue) {
                confirmPasswordError = "Confirm password is required";
            } else if (fieldValue !== allUsers.password) {
                confirmPasswordError = "Passwords do not match";
            }

            setErrors((prev) => ({ ...prev, confirmPassword: confirmPasswordError }));
        }

        if (name === "email") {
            if (!fieldValue) {
                setErrors((prev) => ({ ...prev, email: "Email is required", }));
            } else if (!/\S+@\S+\.\S+/.test(fieldValue)) {
                setErrors((prev) => ({ ...prev, email: "Email is not valid", }));
            } else {
                setErrors((prev) => ({ ...prev, email: "", }));
            }
        }

        // First & Last Name validation
        if (name === "firstName" || name === "lastName") {
            let nameError = "";
            if (!/^[a-zA-Z]*$/.test(fieldValue)) {

                nameError = `${name === "firstName" ? "First name" : "Last name"} must contain only letters`;
                setErrors((prev) => ({ ...prev, [name]: nameError }));
                return
            }
            setErrors((prev) => ({ ...prev, [name]: nameError }));
        }

        setAllUsers((prevState) => ({ ...prevState, [name]: fieldValue }));
    };

    const getFullPhoneNumber = () => {
        if (allUsers.phonenumber && allUsers.country) {
            try {
                const phoneNumber = parsePhoneNumber(allUsers.phonenumber, allUsers.country);
                if (phoneNumber) {
                    return phoneNumber.number.slice(1); // remove +
                }
            } catch (error) {
            }
        }
        return '';
    };


    const handlePhoneChange = (value, country) => {
        setErrors(prev => ({ ...prev, phonenumber: "" }));

        const nationalNumber = value.replace(country.dialCode, '');
        const maxLength = getExampleNumber(country?.iso2?.toUpperCase())?.nationalNumber?.length || 15;

        if (nationalNumber.length > maxLength) {
            setErrors(prev => ({
                ...prev,
                phonenumber: `Phone number cannot exceed ${maxLength} digits for ${country?.name || 'this country'}`,
            }));
        }

        setAllUsers(prev => ({
            ...prev,
            phonenumber: value,  // full number with dial code
            country: country?.iso2?.toUpperCase(), // IN, US, etc
        }));
    };

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const validateFocus = (e) => {
        const fieldName = e?.target?.name;
        const fieldValue = e?.target?.value;
        const value = fieldValue.trim();

        let isValid = true;
        let errorMessage = "";

        if (fieldName === "email") {
            if (!emailRegex.test(fieldValue) && value != "") {
                errorMessage = "Email is invalid";
                isValid = false;
            }
        }

        if (fieldName === "password") {
            setPasswordLengthValid(fieldValue?.length >= 8 && fieldValue?.length <= 30);
            setHasUpperLowerCase(/[a-z]/.test(fieldValue) || /[A-Z]/.test(fieldValue));
            setHasNumber(/\d/.test(fieldValue));
            setHasSpecialChar(/[!@#$%^&*(),.?":{}|<>]/.test(fieldValue));

            if (fieldValue === "") {
                setPasswordLengthValid(null);
                setHasUpperLowerCase(null);
                setHasNumber(null);
                setHasSpecialChar(null);
            }

        }
        setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage, }));
        return isValid;
    };

    const validate = () => {
        let formErrors = {};
        let isValid = true;

        if (!allUsers.email) {
            formErrors.email = "Email required";
            isValid = false;
        }
        if (
            allUsers?.email &&
            !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(allUsers?.email)
        ) {
            formErrors.email = "Email invalid";
            isValid = false;
        }

        if (!allUsers.firstName) {
            formErrors.firstName = "First Name required";
            isValid = false;
        } else if (allUsers.firstName.length < 2) {
            formErrors.firstName = "First Name must be at least 2 characters long";
            isValid = false;
        }

        if (!allUsers.lastName) {
            formErrors.lastName = "Last Name required";
            isValid = false;
        } else if (allUsers.lastName.length < 2) {
            formErrors.lastName = "Last Name must be at least 2 characters long";
            isValid = false;
        }

        if (!allUsers.password) {
            formErrors.password = "Password required";
            isValid = false;
        }
        else if (allUsers.password.length < 8 || allUsers.password.length > 30) {
            formErrors.password = "Password must be 8-30 characters long";
            isValid = false;
        }
        else if (!(/[a-z]/.test(allUsers.password))) {
            formErrors.password = "Password must include lowercase letters";
            isValid = false;
        }
        else if (!(/[A-Z]/.test(allUsers.password))) {
            formErrors.password = "Password must include uppercase letters";
            isValid = false;
        }
        else if (!/\d/.test(allUsers.password)) {
            formErrors.password = "Password must include at least one number";
            isValid = false;
        } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(allUsers.password)) {
            formErrors.password = "Password must include at least one special character";
            isValid = false;
        }

        if (!allUsers.confirmPassword) {
            formErrors.confirmPassword = "Confirm Password required";
            isValid = false;
        }
        if (allUsers.confirmPassword !== allUsers.password) {
            formErrors.confirmPassword = "Confirm Password does not match";
            isValid = false;
        }

        const phoneError = isPhoneValid(
            allUsers.phonenumber,
            allUsers.country
        );
        if (phoneError) {
            formErrors.phonenumber = phoneError;
            isValid = false;
        }

        setErrors(formErrors);
        return isValid;
    };

    const isPhoneValid = (phone, countryVal) => {
        if (!phone) {
            return "Phone number is required";
        }

        try {
            const phoneWithPlus = phone.startsWith("+")
                ? phone
                : `+${phone}`;

            const phoneNumber = parsePhoneNumberFromString(
                phoneWithPlus,
                countryVal
            );

            if (!phoneNumber || !phoneNumber.isValid()) {
                return "Please enter a valid phone number";
            }

            return null;
        } catch (err) {
            return "Please enter a valid phone number";
        }
    };

    const dispatch = useDispatch();

    const handleSubmit = async (e) => {
        e.preventDefault();

        const isValid = validate();
        if (!isValid) return;

        let data = {
            email: allUsers?.email,
            password: allUsers?.password,
            phoneNumber: allUsers?.phonenumber,
            firstName: allUsers?.firstName,
            lastName: allUsers?.lastName,
        };

        if (allUsers?.referralCode) {
            data.referralCode = allUsers?.referralCode;
        }

        setLoad(true);
        try {
            const response = await userRegister(data);
            setLoad(false);
            const { success, message, result } = response?.data || {};
            if (success) {
                ToastSuccess({ message, icon: false });
                dispatch(updateOtpTime(result?.time));
                navigate("/verify", { state: { data: result, type: 'register' } });
            } else {
                const backendErrors = {};
                const msg = message?.toLowerCase() || "";

                if (msg.includes("first name")) backendErrors.firstName = message;
                else if (msg.includes("last name")) backendErrors.lastName = message;
                else if (msg.includes("email")) backendErrors.email = message;
                else if (msg.includes("password")) backendErrors.password = message;
                else if (msg.includes("country")) backendErrors.country = message;
                else ToastError({ message: message || "Somthing went wrong" });

                setErrors((prev) => ({ ...prev, ...backendErrors }));
            }
        } catch (error) {
            setLoad(false);
            ToastError({ message: "Something went wrong. Please try again.", icon: false });
        }
    };



    return (
        <div className='auth-page login-page login-page3'>

            <GlobalStyles
                styles={{
                    ':root': {
                        '--Form-maxWidth': '800px',
                        '--Transition-duration': '0.4s',
                    },
                }}
            />

            <Box
                component="main"
                className='login-card login-card3'

            >
                <Link to={'/'}>
                    <div className="logo">
                        <img width={120} src={!isLightMode ? lightLogo : darkLogo} alt="logo" />
                    </div>
                </Link>

                <Stack sx={{ gap: 2, mb: 2 }}>
                    <Stack sx={{ gap: 1 }}>
                        <Typography className="gold-color" component="h1" sx={{ fontSize: '35px', textAlign: 'center' }}>
                            Sign Up
                        </Typography>
                    </Stack>
                </Stack>
                <Stack spacing={4} mt={2}>
                    <Grid2 container spacing={1.5}>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                            <FormControl fullWidth required>
                                <div className='input-common'>
                                    <FormLabel>First Name</FormLabel>
                                    <TextField
                                        fullWidth
                                        type="text"
                                        variant="outlined"
                                        name="firstName"
                                        inputProps={{ maxLength: 20 }}
                                        value={allUsers.firstName}
                                        onChange={handleChange}
                                        onInput={validateFocus}
                                        error={!!errors.firstName}
                                    />
                                </div>
                                {errors.firstName && <InputError error={errors.firstName} />}
                            </FormControl>
                        </Grid2>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                            <FormControl fullWidth required>
                                <div className='input-common'>
                                    <FormLabel>Last Name</FormLabel>
                                    <TextField
                                        fullWidth
                                        type="text"
                                        variant="outlined"
                                        name="lastName"
                                        inputProps={{ maxLength: 20 }}
                                        value={allUsers.lastName}
                                        error={!!errors.lastName}
                                        onChange={handleChange}
                                        onInput={validateFocus}
                                    />
                                </div>
                                {errors.lastName && <InputError error={errors.lastName} />}

                            </FormControl>
                        </Grid2>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>

                            <FormControl fullWidth required>
                                <div className='input-common'>
                                    <FormLabel>Email Address</FormLabel>
                                    <TextField
                                        fullWidth
                                        name="email"
                                        type="email"
                                        inputProps={{ maxLength: 40 }}
                                        value={allUsers.email}
                                        onChange={handleChange}
                                        onInput={validateFocus}
                                        error={!!errors.email}
                                        variant="outlined"
                                    />
                                </div>
                                {errors.email && <InputError error={errors.email} />}

                            </FormControl>
                        </Grid2>

                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <FormControl fullWidth required>
                                <div className='input-common'>
                                    <FormLabel>Phone No</FormLabel>
                                    <PhoneInput
                                        className="PhoneNumber-input mt-16"
                                        country={allUsers.country ? allUsers.country.toLowerCase() : 'in'}
                                        value={allUsers.phonenumber}
                                        countryCodeEditable={false}
                                        enableSearch
                                        international
                                        onChange={handlePhoneChange}
                                        specialLabel=""
                                        inputStyle={{
                                            width: "100%",
                                            height: "48px",
                                            borderRadius: "3px",
                                            borderColor: errors.phonenumber ? "#EF564D" : "#ccc",
                                            backgroundColor: "var(--color-BasicBg)",
                                            color: "var(--color-PrimaryText)",
                                            paddingLeft: "60px", // Add padding to prevent overlap with dropdown
                                        }}
                                        buttonStyle={{
                                            borderRadius: "3px 0 0 3px",
                                            borderColor: errors.phonenumber ? "#EF564D" : "#ccc",
                                            backgroundColor: "var(--color-BasicBg)",
                                            borderLeft: "none",
                                        }}
                                        containerStyle={{
                                            width: "100%",
                                            marginBottom: "10px",
                                        }}
                                    />
                                    {errors.phonenumber && <InputError error={errors.phonenumber} />}
                                </div>
                            </FormControl>
                        </Grid2>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                            <FormControl fullWidth required>
                                <div className='input-common'>
                                    <FormLabel>Password</FormLabel>
                                    <OutlinedInput
                                        id="outlined-adornment-password"
                                        type={showPassword ? 'text' : 'password'}
                                        value={allUsers.password}
                                        onChange={handleChange}
                                        onInput={validateFocus}
                                        name='password'
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label={
                                                        showPassword ? 'hide the password' : 'display the password'
                                                    }
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    onMouseUp={handleMouseUpPassword}
                                                    edge="end"
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                    />
                                </div>
                                {errors.password && <InputError error={errors.password} />}

                            </FormControl>
                        </Grid2>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>

                            <FormControl fullWidth required>
                                <div className='input-common'>
                                    <FormLabel>Confirm Password</FormLabel>
                                    <OutlinedInput
                                        id="outlined-adornment-password"
                                        type={showPassword1 ? 'text' : 'password'}
                                        name="confirmPassword"
                                        onChange={handleChange}
                                        onInput={validateFocus}
                                        value={allUsers.confirmPassword}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label={
                                                        showPassword1 ? 'hide the password' : 'display the password'
                                                    }
                                                    onClick={handleClickShowPassword1}
                                                    onMouseDown={handleMouseDownPassword1}
                                                    onMouseUp={handleMouseUpPassword1}
                                                    edge="end"
                                                >
                                                    {showPassword1 ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                    />
                                </div>
                                {errors?.confirmPassword && <InputError error={errors.confirmPassword} />}
                            </FormControl>
                        </Grid2>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <p style={{ margin: '0', fontSize: '14px' }} className='red mt-5'>Your password must contain at least 8 characters, one uppercase (ex: A, B, C, etc), one lowercase letter, one numeric digit (ex: 1, 2, 3, etc) and one special character (ex: @, #, $, etc)</p>
                        </Grid2>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <Stack spacing={2} mt={2}>
                                <div className='but-one text-center'>
                                    <Button type="submit" variant="contained" fullWidth disabled={load} onClick={handleSubmit}>{load ? "Progressing..." : 'Sign Up'}</Button>
                                </div>
                            </Stack>
                        </Grid2>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <Typography level="body-sm" sx={{ textAlign: 'center' }}>
                                Already have an account? <span className='cta '><Link to="/login" className='hover-underline-animation gold-color' level="title-sm" sx={{ textDecoration: 'none', paddingLeft: '5px', color: '#3665FF', fontSize: '14px' }}> Click here to Sign in.</Link></span>
                            </Typography>

                        </Grid2>

                    </Grid2>
                </Stack>
            </Box>
        </div>
    )
}

export default Register
